import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import {
  ArrowRightStartOnRectangleIcon,
  BellAlertIcon,
  CalendarDaysIcon,
  ChartBarSquareIcon,
  FolderIcon,
  ClipboardDocumentListIcon,
  HomeIcon
} from "@heroicons/react/24/outline";
import { IconButton } from "@material-tailwind/react";
import BrandLogo from "../components/BrandLogo";
import MobileBottomNav from "../components/MobileBottomNav";
import SideNav from "../components/SideNav";
import { useAuth } from "../context/AuthContext";

const NAV_ITEMS = [
  { to: "/dashboard", label: "الرئيسية", icon: HomeIcon },
  { to: "/transactions", label: "المال", icon: ChartBarSquareIcon },
  { to: "/appointments", label: "المواعيد", icon: CalendarDaysIcon },
  { to: "/projects", label: "المشاريع", icon: FolderIcon },
  { to: "/reports", label: "التقارير", icon: ClipboardDocumentListIcon }
];

const PAGE_TITLES = {
  "/dashboard": "لوحة التحكم",
  "/transactions": "الدخل والمصاريف",
  "/appointments": "دفتر المواعيد",
  "/projects": "المشاريع والدفعات",
  "/reports": "التقارير"
};

export default function AppLayout() {
  const location = useLocation();
  const { user, logout } = useAuth();

  const pageTitle =
    Object.entries(PAGE_TITLES).find(([route]) => location.pathname.startsWith(route))?.[1] ||
    "النظام الشخصي";

  return (
    <div className="min-h-screen bg-softbg text-slate-800">
      <div className="mx-auto flex min-h-screen max-w-7xl gap-4 px-2 py-2 sm:px-4 lg:px-6">
        <SideNav navItems={NAV_ITEMS} />

        <div className="flex min-h-screen min-w-0 flex-1 flex-col">
          <header className="sticky top-0 z-20 mb-3 rounded-[24px] border border-white/75 bg-white/88 px-3 py-3 shadow-sm backdrop-blur sm:mb-4 sm:px-4">
            <div className="flex items-center justify-between gap-3">
              <div className="flex min-w-0 items-center gap-3">
                <div className="md:hidden">
                  <BrandLogo compact />
                </div>
                <div className="min-w-0">
                  <h1 className="truncate text-base font-extrabold text-brand-800 sm:text-2xl">
                    {pageTitle}
                  </h1>
                  <p className="truncate text-[11px] text-slate-500 sm:text-sm">{user?.email || "المستخدم الحالي"}</p>
                </div>
              </div>

              <div className="flex items-center gap-1 sm:gap-2">
                <IconButton variant="text" className="rounded-full text-brand-700 hover:bg-brand-50">
                  <BellAlertIcon className="h-5 w-5" />
                </IconButton>

                <button
                  type="button"
                  onClick={logout}
                  className="inline-flex items-center gap-2 rounded-full border border-brand-100 bg-brand-700 px-3 py-2 text-xs font-extrabold text-white transition hover:bg-brand-800 sm:px-4 sm:text-sm"
                >
                  <ArrowRightStartOnRectangleIcon className="h-4 w-4 sm:h-5 sm:w-5" />
                  <span className="hidden sm:inline">تسجيل الخروج</span>
                </button>
              </div>
            </div>
          </header>

          <main className="flex-1">
            <Outlet />
          </main>
        </div>
      </div>

      <MobileBottomNav navItems={NAV_ITEMS} />
    </div>
  );
}
